import React from "react";
import * as R from "ramda";
import Task from "Portal/NewPortal/Sections/Home/Cards/Tasks/View/Task";
import { Div } from "components/Base";
import { connect } from "react-redux";
import CSSModules from "react-css-modules";
import taskStyles from "Portal/NewPortal/Sections/Home/Cards/Tasks/View/styles.scss";
import cx from "classnames";
import { getSessionTasks } from "../../selectors";
import { getters } from "../../model";

const decorate = R.compose(
  connect(
    state => ({
      sessionData: getters.sessionData(state),
      sessionTasks: getSessionTasks(state)
    }),
    {}
  ),
  CSSModules(taskStyles)
);

const Tasks = ({ sessionTasks, sessionData }) => {
  return (
    <div className={cx(taskStyles.tasksContainer, taskStyles.flyoverContainer)}>
      {R.length(sessionTasks) > 0 ? (
        <Div display="column.flex-start.flex-start" style={{ gap: "12px" }}>
          {R.map(task => {
            return (
              <Task
                key={task.id}
                data={task}
                viaSessionSidebar
                sessionId={sessionData.id}
              />
            );
          }, sessionTasks)}
        </Div>
      ) : (
        "No session tasks found"
      )}
    </div>
  );
};

export default decorate(Tasks);
